"use client";

import { styled } from "styled-components";

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
`;

export const Arrow = styled.svg`
  flex-shrink: 0;
  color: var(--Color-Common-Text-Tertiary, #7c8490);
`;
